import type { AuthService } from '@web/data/services';
import { useAuthStore } from './auth_store';

interface AuthRepository {
  beginLogin: (opts?: { returnTo?: string }) => Promise<void>;
  handleAuthCallback: () => Promise<{ returnTo: string | null }>;
  signOut: () => Promise<void>;
  getAccessToken: () => Promise<string | null>;
}

export function createAuthRepository(authService: AuthService): AuthRepository {
  async function beginLogin(opts?: { returnTo?: string }): Promise<void> {
    await authService.beginLogin(opts);
  }

  async function handleAuthCallback(): Promise<{ returnTo: string | null }> {
    const params = new URLSearchParams(globalThis.location.search);
    const oauthError = params.get('error_description') ?? params.get('error');
    if (oauthError) throw new Error(oauthError);
    if (!params.get('code') || !params.get('state')) {
      throw new Error('Missing authorization code or state.');
    }
    const { user, returnTo } = await authService.completeLogin();
    useAuthStore.getState().loadUser(user);
    return { returnTo };
  }

  async function signOut(): Promise<void> {
    try {
      await authService.signOut();
    } finally {
      useAuthStore.getState().loadUser(null);
    }
  }

  function getAccessToken(): Promise<string | null> {
    return authService.getAccessToken();
  }

  return { beginLogin, handleAuthCallback, signOut, getAccessToken };
}
